import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { peopleSearch } from "./peopleSearch";
import { services } from "../services/notificationService";

let personAssignmentCurrentPage = 1;
let dataSet = [];
let personAssignmentHasNextPage = false;
const searchPageSize = 10;

function init() {
    peopleSearch.setSearchUrl("/People/GetPeopleForSiteAssignment/");
    $(document).on("click", ".add-PersonAssignment", function() {
        const $addBtn = $(this);
        $addBtn.prop("disabled", true);
        const row = $(this).closest("tr");
        const id = $("#PersonAssignmentSearchTable").DataTable().row(row).data()[0];
        addPeopleToSite(id, $addBtn);
    });
    $("#btnAddPeopleToSite").click(addPeopleToSite);

    $("#divAddPersonToSiteModal").click(showAddPeopleModal);
    populatePersonAssignmentSearchTable();

    $("#PersonAssignmentNext").click(function() {
        if (!personAssignmentHasNextPage) return;
        $("#PersonAssignmentPrevious").removeClass("disabled");
        personAssignmentCurrentPage++;
        populatePersonAssignmentSearchTable();
    });
    $("#PersonAssignmentPrevious").click(function() {
        if (personAssignmentCurrentPage === 1) return;
        $("#PersonAssignmentNext").removeClass("disabled");
        personAssignmentCurrentPage--;
        populatePersonAssignmentSearchTable();
    });
    $(document).on("click", "#PersonAssignmentSearchBtn", populatePersonAssignmentSearchTable);
}
function addPeopleToSite(id, $addBtn) {
    dataaccess.post({ url: "/api/site/" + $("#hdnSiteId").val() + "/people", data: [id] }).done(function(peopleAssignedView) {
        $("#divSiteAssignedPeopleTable").html(peopleAssignedView);
        populatePersonAssignmentSearchTable();
        services.notificationService.success("Successfully added site assignments");
        $addBtn.prop("disabled", false);
    });
}

function updatePersonAssignmentResultsView() {
    if (!personAssignmentHasNextPage) {
        $("#PersonAssignmentNext").addClass("disabled");
    } else {
        $("#PersonAssignmentNext").removeClass("disabled");
    }
    if (personAssignmentCurrentPage === 1) {
        $("#PersonAssignmentPrevious").addClass("disabled");
    } else {
        $("#PersonAssignmentPrevious").removeClass("disabled");
    }
}

function populatePersonAssignmentSearchTable() {
    const filters = {
        keyword: $("#PersonAssignmentSearchKeyword").val(),
        active: true,
        pageSize: searchPageSize
    };
    $("#PersonAssignmentSearchLoading").show();
    peopleSearch.getPeople(personAssignmentCurrentPage, filters).done(function(results) {
        if (results !== null && results.people !== null && results.people.length !== 0) {
            dataSet = [];
            for (let i = 0; i < searchPageSize && i < results.people.length; i++) {
                dataSet.push([
                    results.people[i].id, results.people[i].aptifyId, results.people[i].firstName, results.people[i].lastName,
                    results.people[i].email
                ]);
            }
            personAssignmentHasNextPage = results.people.length > searchPageSize;
        } else {
            dataSet = [];
            personAssignmentHasNextPage = false;
        }
        const ids = $("#tblSiteAssignment > tbody > tr").map(function() { return parseInt($(this).attr("personid")); }).get();
        $("#PersonAssignmentSearchTable").DataTable({
            "processing": true, // for show progress bar
            "serverSide": false, // for process server side
            "filter": false, // this is for disable filter (search box)
            //"orderMulti": false, // for disable multiple column at once
            "data": dataSet,
            "bLengthChange": false,
            "bPaginate": false,
            "PageLength": searchPageSize,
            "bInfo": false,
            destroy: true,
            "ordering": false,
            "columnDefs":
            [{
                "targets": 0,
                "visible": false,
                "orderable": false,
                "name": "id"
            }, {
                "targets": 1,
                "orderable": false,
                "name": "aptifyId"
            }, {
                "targets": 2,
                "orderable": false,
                "name": "firstName"
            }, {
                "targets": 3,
                "orderable": false,
                "name": "lastName"
            }, {
                "targets": 4,
                "orderable": false,
                "name": "email"
            }, {
                "targets": 5,
                "orderable": false,
                "mRender": function(data, type, row) {
                    if (ids.includes(parseInt(row[0]))) {
                        return "<button type=\"button\" class=\"btn btn-sm btn-danger\" disabled>Added</button>";
                    } else {
                        return "<button type=\"button\" class=\"btn btn-primary add-PersonAssignment\">Add</button>";
                    }
                }
            }
            ]
        });
        $("#PersonAssignmentSearchLoading").hide();
        updatePersonAssignmentResultsView();
    });
}
function showAddPeopleModal() {
    populatePersonAssignmentSearchTable();
    $("#addPersonToSite").modal("show");
}

export const addPersonToSite = {
    init: init
};